"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "parrano": {
    "09917ab3": [{
      "hkey": "c34e8f70",
      "slug": "parrano",
      "name": "Parrano",
      "primary": true,
      "skipSearch": false
    }],
    "cantone": [{
      "hkey": "c34e8f70",
      "slug": "parrano",
      "name": "Parrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cd5d6141": [{
      "hkey": "c34e8f70",
      "slug": "parrano",
      "name": "Parrano",
      "primary": true,
      "skipSearch": false
    }],
    "frattaguida": [{
      "hkey": "c34e8f70",
      "slug": "parrano",
      "name": "Parrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7eddedfa": [{
      "hkey": "c34e8f70",
      "slug": "parrano",
      "name": "Parrano",
      "primary": true,
      "skipSearch": false
    }],
    "pievelunga": [{
      "hkey": "c34e8f70",
      "slug": "parrano",
      "name": "Parrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;